import { render, staticRenderFns } from "./almondco-inshell-sales-order-lot-assignment.vue?vue&type=template&id=50033c04"
import script from "./almondco-inshell-sales-order-lot-assignment.vue?vue&type=script&lang=js"
export * from "./almondco-inshell-sales-order-lot-assignment.vue?vue&type=script&lang=js"
import style0 from "./almondco-inshell-sales-order-lot-assignment.vue?vue&type=style&index=0&id=50033c04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports